// extracted by mini-css-extract-plugin
export var quantityInput = "_nr-0";